
<div class="modal-header bg-warning">
  <h4 class="modal-title text-white">Session Expired</h4>
  <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
  <div class="d-flex align-items-center mb-3">
    <i class="bi bi-exclamation-triangle-fill text-warning me-3" style="font-size: 2rem;"></i>
    <p class="mb-0">Your session has expired due to inactivity. For security purposes, you have been automatically logged out.</p>
  </div>
</div>
<div class="modal-footer d-flex justify-content-center">
  <button type="button" class="btn btn-primary" (click)="close()">OK</button>
</div>
